import {useDispatch, useSelector} from "react-redux";
import React, {useContext, useEffect, useState, useRef} from "react";

import '../sass/components/basket.scss';
import '../sass/components/basket-items.scss';
import closeIcon from "../assets/close-white.svg";

import BasketItem from "./BasketItem";
import {Link} from "react-router-dom";
import Totals from "./Totals";
import {fetchPreprocessOrder} from "../apiRequests/api";
import {useAuth0} from "@auth0/auth0-react";
import {SigninContext} from "../contexts/SigninContext";

function Basket () {
    const [bulkUpdateClass, setBulkUpdate] = useState('')
    const cart = useSelector((state) => state.cart)
    const [updated, setUpdated] = useState(false)
    const [promotionsChecked, setPromotionsChecked] = useState(false)
    // We need to use state, otherwise Map will randomly lose elements.
    const [updatesStatusesMap]  = useState(new Map());
    let totalNett = 0
    let totalVAT = 0
    let grandTotal = 0
    const dispatch = useDispatch()
    const {getIdTokenClaims} = useAuth0()
    const {userName} = useContext(SigninContext)
    const prevItemsRef = useRef(null)

    async function preprocessPromotions() {
        if (cart.items.length === 0) return;
        const hasPromotions = cart.items.some(el => el.ActivePromotions && Object.keys(el.ActivePromotions).length > 0);
        if (!hasPromotions) {
            setPromotionsChecked(true);
            return;
        }
        const token = await getIdTokenClaims();
        const data = await fetchPreprocessOrder({items: cart.items, CustomerAccount: userName}, token.__raw);
        if (data.items) {
            dispatch({type: "UPDATE_CART", payload: data.items});
        }
        setPromotionsChecked(true);
    }

    function bulkUpdate () {
        // TODO needs another decision (now is not enough time)
        var addButtons = document.querySelectorAll('.update-cart-basket-list-table')
        addButtons.forEach(el=> el.click())
        setBulkUpdate('refreshed')
        setTimeout(function(){ setBulkUpdate('') }, 500);
    }
    function clearCart () {
        dispatch({type: "CLEAR_CART", payload: []})
    }
    function handleUpdate(key, new_flag) {
        updatesStatusesMap.set(key, new_flag);
        // If at least one of BasketItems have been updated.
        let to_arr = Array.from(updatesStatusesMap.values());
        let new_updated = to_arr.length > 0 && to_arr.includes(true);
        setUpdated(new_updated);
    }
    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
    },[cart])

    useEffect(() => {
        if (cart.items.length === 0) return;

        // Build a fingerprint of quantities to detect cart changes.
        const fingerprint = cart.items.filter(el => !el._isPromotionalItem).map(el => `${el.Code}:${el.CasesQty}:${el.BottlesQty}`).join('|');
        if (prevItemsRef.current !== null && prevItemsRef.current !== fingerprint) {
            // Cart quantities changed - need to re-check promotions.
            setPromotionsChecked(false);
        }
        prevItemsRef.current = fingerprint;
    }, [cart.items])

    useEffect(() => {
        if (!promotionsChecked && cart.items.length > 0) {
            preprocessPromotions();
        }
    }, [promotionsChecked, cart.items.length])
    return (
        <div className="page basket">
            <h2>Basket</h2>
            <div className='basket-items'>
                {cart.items.length>0&&(
                    <div className="basket-items--cart-control">
                        <button onClick={() => clearCart()} className="basket-items--clear-cart">Empty<img alt={'close'} src={closeIcon}/></button>
                        <button onClick={() => bulkUpdate()}
                                className={`basket-items--update-cart ${bulkUpdateClass}` + (!updated ? ' disabled' : '')}
                                disabled={!updated}>
                            Update Cart
                            <i className="fa fa-refresh"></i>
                        </button>
                    </div>
                )}

                {cart.items.map((el, index)=>{
                    totalNett+=el.CasePrice*el.CasesQty+el.BottlesQty*el.BottleNett
                    totalVAT+=el.BottleVAT*(el.CasesQty*el.CaseSize+el.BottlesQty)
                    grandTotal = totalNett + totalVAT
                    return (
                        <BasketItem key={el.Code} el={el} handleUpdate={handleUpdate} />
                    )
                })}
                {cart.items.length>0 ? (
                    <div className="totals-block-wrapper">
                        <Totals totalNett={totalNett} totalVAT={totalVAT} grandTotal={grandTotal}/>
                        <Link to={updated ? "#" : "/checkout"} className={"main-button checkout-button"  + (updated ? ' disabled' : '')} >Checkout</Link>
                    </div>
                ) : (
                    <div className="flex-col message-empty">
                        <h3>Your basket is empty</h3>
                        <Link to={"/product-list"} className={"main-button checkout-button text-center"}>Return to Product List</Link>
                    </div>
                )}
                {/* <div className='total-block'>
                    <div className='total-col'>
                        {cart.items.length>0?(<>
                            <div className="total-col__row">
                                <h4>Total Nett</h4>
                                <h3>£{numberWithCommas(totalNett.toFixed(2))}</h3>
                            </div>
                            <div className="total-col__row">
                                <h4>Total VAT</h4>
                                <h3>£{numberWithCommas(totalVAT.toFixed(2))}</h3>
                            </div>
                            <div className="total-col__row">
                                <h4>Grand Total</h4>
                                <h3>£{numberWithCommas(grandTotal.toFixed(2))}</h3>
                            </div>
                            <Link to={"/checkout"} className={"main-button checkout-button"}>Checkout</Link>
                        </>):(<>
                            <div className="flex-col message-empty">
                                <h3>Your basket is empty</h3>
                                <Link to={"/product-list"} className={"main-button checkout-button text-center"}>Return to Product List</Link>
                            </div>
                        </>)}
                    </div>
                </div> */}
            </div>
        </div>
    )
}
export default Basket